const CARDS = [
  ['total', 'Total registered', ''],
  ['not_started', 'Assessment not started', 'not_started'],
  ['in_progress', 'Assessment in progress', 'in_progress'],
  ['completed', 'Assessment completed', 'completed'],
  ['not_contacted', 'Not yet contacted', 'not_contacted'],
  ['follow_up', 'Follow-up due', 'follow_up'],
  ['consultation_interested', 'Consultation interested', 'consultation_interested'],
];

export const EngagementCards = ({ counts, card, onCard }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-7 gap-3" data-testid="engagement-cards">
    {CARDS.map(([key, label, filter]) => {
      const active = card === filter;
      return (
        <button key={key} type="button" onClick={() => onCard(active ? '' : filter)} data-testid={`engagement-card-${key}`}
          className={`text-left rounded-2xl border p-4 transition-colors ${active ? 'bg-[#0b1f4d] border-[#0b1f4d] text-white' : 'bg-white border-slate-200 hover:border-teal-400'}`}>
          <p className={`text-[11px] font-semibold uppercase tracking-wider ${active ? 'text-teal-300' : 'text-slate-500'}`}>{label}</p>
          <p className="font-outfit text-3xl font-bold mt-1" data-testid={`engagement-count-${key}`}>{counts?.[key] ?? '–'}</p>
        </button>
      );
    })}
  </div>
);
